import React from "react";

const ProductCategoryContext = React.createContext();

export { ProductCategoryContext };